import ApiService from 'app/services/ApiService';

export const GET_KEYUSER_LIST_REQUEST = 'GET_KEYUSER_LIST_REQUEST'
export const GET_KEYUSER_LIST_SUCCESS = 'GET_KEYUSER_LIST_SUCCESS'
export const GET_KEYUSER_LIST_FAILURE = 'GET_KEYUSER_LIST_FAILURE'

export const POST_KEYUSER_REQUEST = 'POST_KEYUSER_REQUEST'
export const POST_KEYUSER_SUCCESS = 'POST_KEYUSER_SUCCESS'
export const POST_KEYUSER_FAILURE = 'POST_KEYUSER_FAILURE'

export const DELETE_KEYUSER_REQUEST = 'DELETE_KEYUSER_REQUEST'
export const DELETE_KEYUSER_SUCCESS = 'DELETE_KEYUSER_SUCCESS'
export const DELETE_KEYUSER_FAILURE = 'DELETE_KEYUSER_FAILURE'
export const DELETE_KEYUSER_CANCELED = 'DELETE_KEYUSER_CANCELED'

export const SAVE_PAGINATION = 'SAVE_PAGINATION';
export const SAVE_FILTER = 'SAVE_FILTER';
export const CLEAR_REDUCER = 'CLEAR_REDUCER';

export const EXPORT_REQUEST = 'EXPORT_REQUEST';
export const EXPORT_SUCCESS = 'EXPORT_SUCCESS';
export const EXPORT_FAILURE = 'EXPORT_FAILURE';

export const GET_EMPLOYEE_LIST_REQUEST = 'GET_EMPLOYEE_LIST_REQUEST'
export const GET_EMPLOYEE_LIST_SUCCESS = 'GET_EMPLOYEE_LIST_SUCCESS'
export const GET_EMPLOYEE_LIST_FAILURE = 'GET_EMPLOYEE_LIST_FAILURE'

export const getEmployeesForKU = (params) => dispatch => {
    dispatch({ type: GET_EMPLOYEE_LIST_REQUEST });
    ApiService.getEmployeesForKeyusers(params).then(
        response => {
            dispatch({
                type: GET_EMPLOYEE_LIST_SUCCESS,
                payload: response
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_EMPLOYEE_LIST_FAILURE, payload: error.response.message });
        }
    )
}

export const getKeyUsers = (params) => dispatch => {
    dispatch({ type: GET_KEYUSER_LIST_REQUEST });
    ApiService.getKeyUsersCatalogue(params).then(
        response => {
            dispatch({
                type: GET_KEYUSER_LIST_SUCCESS,
                payload: response
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_KEYUSER_LIST_FAILURE, payload: error.response.message });
        }
    )
}

export const postKeyUser = (params) => dispatch => {
    dispatch({ type: POST_KEYUSER_REQUEST });
    ApiService.postNewKeyUser(params).then(
        (response) => {

            dispatch({
                type: POST_KEYUSER_SUCCESS,
                payload: response
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: POST_KEYUSER_FAILURE, payload: error.response.message });
        }
    )
}

export const deleteKeyUser = (params, callback) => dispatch => {
    dispatch({ type: DELETE_KEYUSER_REQUEST });
    ApiService.deleteKeyUserCatalogue(params).then(
        (response) => {
            dispatch({
                type: DELETE_KEYUSER_SUCCESS,
                payload: response
            });

            if (typeof callback === 'function') {
                callback();
            }
        }
    ).catch(
        (error) => {
            const { response } = error;
            if(response.status === 409){
                dispatch({ type: DELETE_KEYUSER_CANCELED, payload: "No se puede eliminar el Keyuser"});
            }else{
                dispatch({ type: DELETE_KEYUSER_FAILURE, payload: error.response.message });
            }            
        }
    )
}

export const exportXls = (param) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: EXPORT_REQUEST });
    ApiService.downloadLayoutKeyUser(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, "ListadoKU.xlsx");

            dispatch({ type: EXPORT_SUCCESS });
        }
    ).catch(
        (error) => {
            dispatch({ type: EXPORT_FAILURE, payload: error.response.message });
        }

    )
}

export const savePagination = (data) => dispatch => {
    dispatch({
        type: SAVE_PAGINATION,
        payload: data,
    })
}

const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
};

